var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,14.833V2.843c1.674.634,3.214,1.611,4.519,2.915l6.387,6.391c1.305,1.303,2.283,2.844,2.917,4.517h-11.99c-1.012,0-1.833-.823-1.833-1.833h0ZM26.329,37.713c-1.491,1.49-2.328,3.511-2.328,5.619v2.667h2.668c2.108,0,4.129-.838,5.619-2.328l12.48-12.48c1.645-1.645,1.645-4.314,0-5.958s-4.314-1.645-5.958,0l-12.48,12.48h0ZM20.334,43.333c0-3.102,1.208-6.019,3.401-8.212l12.48-12.48c.713-.713,1.544-1.261,2.44-1.652-.007-.22-.017-.438-.031-.658h-12.789c-3.032,0-5.5-2.468-5.5-5.5V2.044c-.295-.02-.59-.044-.889-.044h-8.278C6.112,2,2,6.112,2,11.167v25.667c0,5.054,4.112,9.167,9.167,9.167h9.167v-2.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.28fe7c729377bd64b5cd7d01b2e99f28.svg";
export { ForwardRef as ReactComponent };